import { SpaFooterContextProps } from '@chewy/header-footer-react/dist/components/react/src/footer/spa/spa-footer.context';
import { HEADER_FOOTER_SPA_BASE_URL, PAGE_TYPE_MAIN, PAGE_TYPE_MEMORIAL } from '../util/config';

const getSpaFooterContext = (
  usesMinimalFooter?: boolean,
  userContext?: Object,
): SpaFooterContextProps => ({
  pageType: usesMinimalFooter ? PAGE_TYPE_MEMORIAL : PAGE_TYPE_MAIN,
  baseURL: HEADER_FOOTER_SPA_BASE_URL,
  mountElemId: usesMinimalFooter ? 'minimal-footer' : 'footer',
  userContext: userContext ? JSON.stringify({ userContextData: userContext }) : undefined,
});

export default getSpaFooterContext;
